import React from 'react';
import { Link } from 'react-router-dom';
import {
	GovCard,
	GovFlex,
	GovGrid,
	GovGridItem,
	GovIcon,
} from '@gov-design-system-ce/react';
import { parseIcon } from '@gov-nx/component/common';
import type { TileLinkItemProps, TileLinkListProps } from '@gov-nx/ui/types';

export const TileLinkList = ({ items }: TileLinkListProps) => (
	<GovGrid
		gap="l"
		className="mt-(--templates-margin-l)!">
		{items.map((item) => (
			<GovGridItem
				key={`${item.label}-${item.link}`}
				column="12"
				columnMd="4">
				<TileLinkListItem {...item} />
			</GovGridItem>
		))}
	</GovGrid>
);

export const TileLinkListItem = ({ label, link, icon }: TileLinkItemProps) => {
	const parsedIcon = icon ? parseIcon(icon) : null;

	const renderContent = () => (
		<GovFlex
			gap="m"
			alignItems="center"
			responsive="false">
			{parsedIcon ? (
				<span className="flex rounded-full bg-gradient-to-t to-primary-100 from-primary-200 dark:to-(--background-primary-subtle) dark:from-(--background-primary-subtlest) p-(--spacing-s-nudge)">
					<GovIcon
						name={parsedIcon.name}
						type={parsedIcon.type}
						size="2xl"
					/>
				</span>
			) : null}
			<h3 className="text-headline-s!">{label}</h3>
		</GovFlex>
	);

	return (
		<GovCard
			direction="horizontal"
			// @TODO clickable={true}
			asChild={!!link}>
			{link ? (
				<Link
					to={link}
					className="min-h-[92px] no-underline!">
					{renderContent()}
				</Link>
			) : (
				renderContent()
			)}
		</GovCard>
	);
};
